import { Card } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';
import NewAnalysisFormSkeleton from './NewAnalysisFormSkeleton';

const Block = ({
  width,
  height,
  className = ''
}: {
  width: number | string;
  height: number;
  className?: string;
}) => (
  <span className={`d-block ${className}`.trim()}>
    <TextLoading
      width={width}
      height={height}
      isWidthPx={typeof width === 'number'}
    />
  </span>
);

const HistoryPreload = () => (
  <div className="pb-4" aria-hidden>
    <NewAnalysisFormSkeleton />

    <div className="mt-3">
      <div className="d-flex justify-content-end gap-2 mb-2">
        <Block width={34} height={28} />
        <Block width={34} height={28} />
      </div>

      <Card className="border overflow-hidden">
        <div className="d-flex align-items-center gap-3 bg-body-tertiary border-bottom px-3 py-3">
          {[18, 14, 12, 12, 10, 6].map((width, index) => (
            <Block key={index} width={`${width}%`} height={12} />
          ))}
        </div>

        {Array.from({ length: 8 }, (_, row) => (
          <div
            key={row}
            className="d-flex align-items-center gap-3 border-bottom px-3 py-3"
          >
            {[28, 14, 12, 12, 10, 6].map((width, column) => (
              <Block key={column} width={`${width}%`} height={12} />
            ))}
          </div>
        ))}
      </Card>
    </div>
  </div>
);

export default HistoryPreload;
